import { procurementAPI } from "../../axios";

export const actions = {

    //PreplanningApiResource
    GetPrePlanningApiResources(context, data){
        return procurementAPI.get(`PreplanningApiResource/${data.apiId}/${data.budgetId}`);
    },
    GetAllPrePlanningApiResources(context, data){
        return procurementAPI.get(`PreplanningApiResource/BLI/${data}`);
    },
    GetPrePlanningApiResourcesByApi(context, data){
        return procurementAPI.get(`PreplanningApiResource/Api/${data}`);
    },
    GetSinglePrePlanningApiResource(context, data){
        return procurementAPI.get(`PreplanningApiResource/${data}`);
    },
    UpdatePrePlanningApiResource(context, data){
        return procurementAPI.put(`PreplanningApiResource/${data.id}`, data);
    },
    DeletePrePlanningApiResource(context, data){
        return procurementAPI.delete(`PreplanningApiResource/${data}`);
    },
    CreatePrePlanningApiResource(context, data){
        return procurementAPI.post(`PreplanningApiResource/Create`, data);
    },
    
}